module.exports = " <input type=text class=\"form-control type-text\" autofocus=autofocus v-model=formData.fields.title /> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/publish/MetaFields/Title.vue
// module id = 288
// module chunks = 0